import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWalletinline = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 64,
	height: 64,
	viewBox: "0 0 64 64",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		transform: "translate(2 7)",
		stroke: "currentColor",
		strokeWidth: 2,
		fill: "none",
		fillRule: "evenodd",
		strokeLinejoin: "round",
		children: [
			/* @__PURE__ */ _jsx("path", { d: "M45.6 5h6.6A4.8 4.8 0 0157 9.8v12.195m0 14.43V45.2a4.8 4.8 0 01-4.8 4.8H4.8A4.8 4.8 0 010 45.2V9.8A4.8 4.8 0 014.8 5H30" }),
			/* @__PURE__ */ _jsx("path", {
				d: "M13 15c1 0 .532-.729 1-1 5.12-2.969 13.12-7.422 24-13.36 2.272-1.317 4.688-.536 6 1.746C47.896 7.629 50.563 11.5 52 14M9 15h48",
				strokeLinecap: "square"
			}),
			/* @__PURE__ */ _jsx("path", { d: "M44 22h12a4 4 0 014 4v6a4 4 0 01-4 4H44a7 7 0 010-14z" }),
			/* @__PURE__ */ _jsx("circle", {
				cx: 45,
				cy: 29,
				r: 2
			})
		]
	})
});
export default SvgWalletinline;
